import type { ThemeUnit } from "../../types";
import { pxToUnit } from "../utils";

const createDimension = (unit: ThemeUnit) =>
  ({
    sm: pxToUnit(30, unit),
    md: pxToUnit(36, unit),
    lg: pxToUnit(42, unit),
  }) as const;

export const dimensionRem = createDimension("rem");
